import { render, staticRenderFns } from "./palleteBlock.vue?vue&type=template&id=55e26df4"
import script from "./palleteBlock.vue?vue&type=script&lang=js"
export * from "./palleteBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports